import { formatDistanceToNow, parseISO, format } from "date-fns";

/** Map severity to Badge variant name. */
export function severityVariant(severity: string) {
  switch (severity) {
    case "critical":
      return "critical" as const;
    case "high":
      return "high" as const;
    case "medium":
      return "medium" as const;
    case "low":
      return "low" as const;
    default:
      return "secondary" as const;
  }
}

/** Format ISO timestamp as relative time (e.g. "5 minutes ago"). */
export function formatRelativeTime(iso: string): string {
  try {
    return formatDistanceToNow(parseISO(iso), { addSuffix: true });
  } catch {
    return iso;
  }
}

/** Format ISO timestamp as absolute (e.g. "Mar 12, 2026 14:30:05"). */
export function formatAbsoluteTime(iso: string): string {
  try {
    return format(parseISO(iso), "MMM d, yyyy HH:mm:ss");
  } catch {
    return iso;
  }
}

/** Status display colors (Tailwind classes). */
export const statusColors: Record<string, string> = {
  new: "text-blue-400",
  acknowledged: "text-yellow-400",
  investigating: "text-orange-400",
  resolved: "text-green-400",
};

export const statusBgColors: Record<string, string> = {
  new: "bg-blue-500/20 text-blue-400",
  acknowledged: "bg-yellow-500/20 text-yellow-400",
  investigating: "bg-orange-500/20 text-orange-400",
  resolved: "bg-green-500/20 text-green-400",
};
